module.exports = __webpack_public_path__ + "img/16.ba0327bb.jpg";